module.exports = __webpack_public_path__ + "static/img/wanted.a4f58a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted.png
// module id = eOAT
// module chunks = 1 3